import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import {useState} from 'react';
import {CalendarDays, Palette, Smartphone} from 'lucide-react';
import './ClientAppShowcase.css';
import ClientAppDemo from './ClientAppDemo';

const THEMES = [
  {name:'Rosso',accent:'#ff3932',surface:'#111113',ink:'#ffffff'},
  {name:'Avorio',detail:'#765426',success:'#246b49',accent:'#dcc7a1',surface:'#ece6db',ink:'#201e1b'},
  {name:'Viola',accent:'#b29aff',surface:'#171320',ink:'#ffffff'},
];
export default function ClientAppShowcase(){
  useUiLanguage();
  const [selected,setSelected]=useState(0);
  const theme=THEMES[selected];
  return <div className="tps-client-showcase">
    <div className="tps-client-pitch">
      <p className="tps-eyebrow">{tr("Il tuo brand. Anche sul loro telefono.")}</p>
      <h3>{tr("Il legame con il cliente")}<br/><em>{tr("ha la tua firma.")}</em></h3>
      <p>{tr("Con TPS crei l’app del tuo studio e ne personalizzi la grafica. Dal logo alle immagini, dai colori ai contenuti: un’esperienza che parla di te, già dal primo accesso.")}</p>
      <ul>
        <li><Palette aria-hidden="true"/><span><strong>{tr("Riconoscibile, a colpo d’occhio.")}</strong>{tr("La tua identità accompagna servizi, professionisti e presentazione dello studio.")}</span></li>
        <li><CalendarDays aria-hidden="true"/><span><strong>{tr("Utile, ogni giorno.")}</strong>{tr("I clienti possono inviare richieste e ritrovare appuntamenti, proposte e documenti nel proprio spazio.")}</span></li>
        <li><Smartphone aria-hidden="true"/><span><strong>{tr("Sempre a portata di mano.")}</strong>{tr("Un’app installabile sul telefono, collegata al lavoro dello studio e dei professionisti.")}</span></li>
      </ul>
      <div className="tps-theme-picker" role="group" aria-label={tr("Prova i colori dell’esempio grafico")}>
        <p>{tr("Immaginala con i tuoi colori")}</p>
        {THEMES.map((item,i)=><button type="button" key={item.name} aria-pressed={selected===i} onClick={()=>setSelected(i)}><span style={{background:item.accent}} aria-hidden="true"/>{tr(item.name)}</button>)}
      </div>
    </div>
    <ClientAppDemo theme={theme} />
  </div>;
}
